import clsx from "clsx";
import { resolveResponsiveProp } from "../../utils/resolveResponsiveProp.mjs";
import { preventCollapsePseudo, left, bottom, right, top } from "./negativeMargin.css.mjs";
const directionStyles = {
  top,
  right,
  bottom,
  left
};
const negativeMargin = (direction, space) => space ? clsx([
  direction === "top" || direction === "bottom" ? preventCollapsePseudo[direction] : void 0,
  resolveResponsiveProp(
    space,
    directionStyles[direction].mobile,
    directionStyles[direction].tablet,
    directionStyles[direction].desktop,
    directionStyles[direction].wide
  )
]) : null;
export {
  negativeMargin
};
